
"use strict"; // jshint ignore:line

//import { TransformControls }   from '../../../../node_modules/three/examples/jsm/controls/TransformControls.js';
import { TransformControls } from '../../../../node_modules/three/examples/jsm/controls/TransformControls.js';
import {
	PointLightHelper,
	SpotLightHelper,
	HemisphereLightHelper,
	BoxHelper,
	Vector2,
	Vector3
} from '../../../../src/js/three.module.js';

// import {
//	RectAreaLightHelper,
//	LightProbeHelper,
//} from '../../../../src/js/three.module.js';

import { RectAreaLightHelper } from '../../../../node_modules/three/examples/jsm/helpers/RectAreaLightHelper.js';
import { LightProbeHelper } from '../../../../node_modules/three/examples/jsm/helpers/LightProbeHelper.js';

import { mouse, parseFirstIntersect, screenIntersects, getIntersects, roundVector, screenPosRaycaster, THREEx } from '../../GameTools.js';
import { isUpwardFacingIntersect } from '../../../utils/intersections/utils.js';

import { TextLabel }           from '../../classes/TextLabel.js';
import { ObjectClickHandler }  from '../../../utils/object-click-handler.js';
import { Oeuvre }              from '../../classes/oeuvre.js';
import { Painting }            from '../../classes/painting.js';
import { Statue }              from '../../classes/statue.js';
import { adjustPointToHeight } from '../../classes/Player.js';
import { WallService }         from "../../services/WallsHandlerService.js";
import { DragHandle }          from "../../services/DragHandlesService.js";
import { ObjectSolverByUuid }  from '../../services/ObjectSolverService.js';
import { isObjectMoveable }    from '../../../utils/object-properties/is-object.js';


export class GameSceneStateComponentController {

	static $inject = ["$scope","$rootScope","$state","$timeout","$injector","$templateRequest","$q","gettextCatalog","gameSceneService","HUDService","additionalObjectService","contextMenuService","dragHandlesService","ArrangementService","$oeuvresHandler","scene","arrangement","wallsHandlerService","entitySelectionService","catalogsService","spherical360SetupService","userActionHistoryService","$playerHandler"];

	constructor( $scope, $rootScope, $state, $timeout, $injector, $templateRequest, $q, gettextCatalog, gameService, HUDService,  additionalObjectService,  contextMenuService,  dragHandlesService,  ArrangementService,  $oeuvresHandler,  scene,  arrangement,  wallsHandlerService,  entitySelectionService, catalogsService,  spherical360SetupService, actStack, $playerHandler ) {

		// setTimeout(function(){ window.history.forward(); }); // WTF? 9.9.2021 -m 


		var renderer;

		/***************/

		// Injektoidaan yläpalkkiin, jos vielä ei sitä löydy, painike näkymän kasvattamiseksi koko ruudulle
		/*setTimeout(function() {

			var warpper_selector = "#artestUserBar  > .container-fluid > .navbar-header";

			try {
				var btn = $( warpper_selector + " .btn-toggle-fullscreen" );

				if (!btn[0]) {

					btn = $( '<a class="pull-right btn btn-link navbar-btn btn-toggle-fullscreen visible-state--scene" onclick="(window.toggleFullscreen||document.body.requestFullscreen)();event.stopPropagation()"><span class="glyphicon glyphicon-fullscreen"></span></a>' );

					$( warpper_selector ).append( btn );
				}

			} catch (error) {
				console.error( error );
			}
		});*/

		/***************/

		contextMenuService.setArrangement( arrangement );

		gameService.$ready.then(function() {

			if (window.WELCOME_MODAL) {
				console.info( "Waiting for WELCOME_MODAL.result" );

				var dtime = Date.now() - window.WELCOME_MODAL.stime;

				var timeout = window.WELCOME_MODAL.timeout_ms || 1500;

				setTimeout(() => {

					if (window.WELCOME_MODAL) {
						window.WELCOME_MODAL.close();
					}

				}, (Date.now() - window.WELCOME_MODAL.stime) > timeout ? 0 : (timeout - (Date.now() - window.WELCOME_MODAL.stime)));

				return window.WELCOME_MODAL.result
			}

		}).finally(function() {

			return init();

		}).then(function() {

			$rootScope.$broadcast( "$pageCtrlReady", $state.current );

		}).catch(function( error ) {

			console.error( error );

			Notification.error({
				title: "Unable to start scene!",
				message: error.toString()
			});

			$rootScope.loading = false;

			$injector.get( "$uibModal" ).open({
				keyboard: false,
				backdrop: 'static',
				template: "<h2 class='m-0 mb-3'>Vakava virhe!</h2><div class='alert alert-danger'><h4 class='m-0 mb-2' ng-if='error.message'>{{ error.message }}</h4><pre ng-if='error.stack'>{{ error.stack }}</pre><pre class='m-0'>{{ error | json }}</pre></div><div><a class='btn btn-default' href='#!/arrangements'><b class='glyphicon glyphicon-chevron-left'></b> Palaa etusivulle</a></div>",
				controller: [ "$uibModalInstance", "$scope", function( $uibModalInstance, $scope ) {
					$scope.error = error;
				}]
			});


	//		$state.go( "arrangements", $state.params );

		});

		$scope.arrangement = arrangement;
		$scope.scene       = scene;

		$scope.addPainting = function( oeuvre ){ return gameService.addPainting( oeuvre ); };
		$scope.addStatue   = function( oeuvre ){ return gameService.addStatue(   oeuvre ); };
		$scope.addOeuvre   = function( oeuvre ){ return gameService.addOeuvre(   oeuvre ); };

		/****************/

		// Alustetaan teoksen katselua varten modal-ikkuna
		var oeuvreInfoModalOpener = null;
		var openOeuvreInfoModal = (function() {

			var opts = {
				templateUrl        : "templates/oeuvre-info-modal.html",
				controllerBasepath : "js/controllers/",
				size               : "lg"
			};

			var modal;

			return function openOeuvreInfoModal( oeuvre_uid ) {

				/********************/
				try {

					let catalog = catalogsService.solveCurrentCatalog( catalogsService.solveCatalogs( arrangement ));

					if (catalog) {

						let object = ObjectSolverByUuid( oeuvre_uid, 'oeuvre' );
						
						let catalog_item = catalog.solveItemByObject( object );

						if (catalog_item) {

							catalogsService.openCatalogItemViewer( catalog_item, catalog, arrangement );

							return;
						}
					}

				} catch (e) {}
				/********************/

				if (!oeuvreInfoModalOpener) {

					try {
						if ($injector.get( "$templateCache" ).get( "oeuvre-info-modal.html" )) {
							opts.templateUrl = "oeuvre-info-modal.html";
						}
					} catch (error) {}

					oeuvreInfoModalOpener = $injector.get( "modalOpenerGenerator" ).generate( "oeuvre-info-modal", opts, [ "oeuvre" ]);
				}
				return $injector.get( "$userAssets" ).getClientOeuvreSingles([ oeuvre_uid ]).then(function( oeuvres ) {

					return modal = oeuvreInfoModalOpener( oeuvres[0], { });

				});
			}
		})();

		var _autoSavingTimeout = null, autoSavingInterval = 60000;
		var running = true;

		var keyboardState;
		var sceneContainer; // #container, jonka sisällä cavas't

		function init( ){

			window._view_game_scene_controlled_initialized = true;

			for (var uid in $oeuvresHandler.oeuvres) gameService.addOeuvre( $oeuvresHandler.oeuvres[ uid ]);

			scene.add( additionalObjectService );

			scene.add( player.camera );

			scene.add( window.paintingTool );

			sceneContainer = document.getElementById( "container" );

			renderer = gameService.setRenderer({
				canvas: document.getElementById( "rendererCanvas" ),
			});

			/***************/

			if (arrangement.$editable) {
				HUDService.transformCtrl = new TransformControls( player.camera, sceneContainer );
				HUDService.transformCtrl.setSpace( "local" );
			}

			if (HUDService.transformCtrl) try {
				(() => {
					/*
					* Koska moottori toteuttaa omaa "pinnoille asettelu" -toimintaansa objekteja raahaillessa,
					* poistetaan TranslateControl'sta toiminnallisuus kaikkien akselien suuntaisesti liikuttamiseen.
					* Häkkyrän keskellä oleva OctahedronBufferGeometry osuu usein hiiren tielle, erityisesti pienissä objekteissa
					*/

					var transformControlsGizmo = HUDService.transformCtrl.children[0];

					destroyGizmoControl( "translate", "XYZ" );
					destroyGizmoControl( "translate", "XY" );
					destroyGizmoControl( "translate", "YZ" );
					destroyGizmoControl( "translate", "XZ" );

					destroyGizmoControl( "rotate", "E" );

					function destroyGizmoControl( mode, name ) {

						for (let i = 0, mesh; mesh = transformControlsGizmo.picker[ mode ].children[ ++i ];) {

							if (mesh.name == name) mesh.parent.remove( mesh );
						}

						for (let i = 0, mesh; mesh = transformControlsGizmo.gizmo[ mode ].children[ ++i ];) {

							if (mesh.name == name) mesh.parent.remove( mesh );
						}
					}
				})();
			} catch (error) { console.error(error); }

			HUDService.init( document.getElementById( "HUDCanvas" ), arrangement.$config.HUDService || { });

			if (HUDService.transformCtrl) {
				scene.add( HUDService.transformCtrl );
			}

			/***************/


			/** CONTEXT MENUS */

			if (gameService.inEditor()) setTimeout(function() {

				var templates = [];

				for (var key in  contextMenuService.modals) {
					if (templates.indexOf( contextMenuService.modals[key].templateUrl ) == -1) {
						templates.push( contextMenuService.modals[key].templateUrl );
					}
				}

				templates.forEach( $templateRequest );

			}, 1000 );

			contextMenuService.buildTemplateScope([ "templates/context-modals/oeuvres.html" ], {
				onOpen: function() {

					if (this.data && this.data.oeuvre) {
						try {

							let catalog = catalogsService.solveCurrentCatalog( catalogsService.solveCatalogs( arrangement ));

							let catalog_item = catalog.solveItemByObject( this.data.oeuvre );

							if (catalog_item) {
								this.extend.catalog_item = catalog_item;
								this.extend.openCatalogItemViewer = item => {
									catalogsService.openCatalogItemViewer( item, catalog, arrangement );
									this.$close();
								};
							}
						} catch (e) {}
					}
				},
				toggleOeuvreVisibility: function( oeuvre ){
					oeuvre.toggleVisibility();

					//if( !oeuvre.mesh.visible && $rootScope.selected_oeuvre == oeuvre ) $scope.selectOeuvre(null);

					helpers.refreshOeuvreHelper( oeuvre );
				},
				removeOeuvreFromArrangement: function( oeuvre ){
					if (window.confirm( gettextCatalog.getString( "Are you sure you want to remove this oeuvre from current arrangement?" ) )){
						gameService.rmOeuvre( oeuvre );
					}
				},
				showHelperLinesOnSameWall: function( oeuvre ){
					console.log( "contextMenuScopse :: showHelperLinesOnSameWall", oeuvre );
					console.error( "Not implemented yet!" );
				},
				setToSpesificHeight: function( offset ) {
					if (typeof offset == "string") offset = parseFloat(offset.replace(",", "."));
					if (isNaN( offset ) || offset < 0) return;

					// Senttimetrit metreiksi, target.helper_bottomLine.length on metreinä
					offset /= 100;

					var targets = this.extend.multiple ? this.extend.targets : [ this.data.oeuvre ], target, delta;
					for (var i in targets) {
						try {
							target = targets[i];
							if (!target.helper_bottomLine) continue;

							delta = parseFloat(offset) - parseFloat( target.helper_bottomLine.length );

							target.mesh.translateY( delta );
							target.setPlace();

							target.helper_bottomLine.refreshByOeuvre();
						} catch( error ) { console.error(error); }
					}
					return offset;
				},
				calcBtmHeight: function() {
					var heights = (this.extend.multiple ? this.extend.targets : [ this.data.oeuvre ]).map(function(v) {
						return !v.helper_bottomLine ? null : (Math.round(v.helper_bottomLine.length*1000)/10) // Metrit senttimetreiksi, target.helper_bottomLine.length on metreinä
					}).filter(function( v, i, a ){
						return (v != null) && (a.indexOf(v) == i);
					});

					return heights.length == 1 ? heights[0] : null;
				},

				calcZOffset: function () {
					let z_offsets = (this.extend.multiple ? this.extend.targets : [ this.data.oeuvre ]).map( obj => {
						if (typeof obj.z_offset == "number") {
							return Math.round( obj.z_offset * 1000 ) / 10; // Metrit senttimetreiksi, obj.z_offset on metreinä
						}
					}).filter(( v, i, a ) => {
						return (v != null) && (a.indexOf( v ) == i);
					});

					return z_offsets.length == 1 ? z_offsets[0] : null;
				},

				setToSpesificZOffset: function( value_cm ) {

					if (typeof value_cm == "string") value_cm = parseFloat( value_cm.replace( ",", "." ) );

					if (typeof value_cm != "number" || isNaN( value_cm )) return null; 

					let value_m = value_cm / 100;

					let targets = this.extend.multiple ? this.extend.targets : [ this.data.oeuvre ];

					for (let target of targets) {
						if (target instanceof Oeuvre) {
							actStack.do( "oeuvre.setZOffset", target, value_m );
						} else if (target instanceof AdditionalObject) {
							actStack.do( "additionalObject.setZOffset", target, value_m );
						}
					}

					return value_cm;
				},
				editOeuvreSize: function( v, oeuvre ){
					var val = ({ w: oeuvre.width_cm, h: oeuvre.height_cm, d: oeuvre.depth_cm })[ v ];

					if (val === undefined) return;

					var nval = window.promptNumber( "asdasd", val, "sadsad");
					
					if (nval && nval != val) {
						oeuvre.setSize( v, nval / 100 );
					}
				},
				setOeuvreSize: function( w, h, d ) {
					if (w!==null)      this.data.oeuvre.setSize( 'w', w/100 );
					if (h!==null)      this.data.oeuvre.setSize( 'h', h/100 );
					if (d!==undefined) this.data.oeuvre.setSize( 'd', d ? d/100 : null );
				},
				arrangement: arrangement
			});

			contextMenuService.elemTriggers['oeuvre'] = function( elem, event ){
				var oeuvre = angular.element( elem ).scope().oeuvre;

				event.pointY = event.clientY - window.innerHeight + renderer.domElement.clientHeight;

				if (gameService.editor) {

					var selection = entitySelectionService.solveSelection(), extend;

					if (selection.type == "oeuvre" && selection.targets.length > 1 && selection.targets.indexOf( oeuvre ) != -1) {
						extend = { multiple: true, targets: selection.targets, btm_height: null };

						for (var i in selection.targets) {

						}
					}

					contextMenuService.run( "preview-oeuvre-"+oeuvre.uid, event.clientX, event.pointY, extend );

				} else {
					// Editori ei ole auki!

					try {

						openOeuvreInfoModal( oeuvre.uid );

						//var modal = $rootScope.$ArtestUserBarService.OpenOeuvreViewerModal({ uid: oeuvre.uid });
					} catch (error) {
						console.error( error );
					}
				}

				return false;
			};

			contextMenuService.buildTemplateScope( "templates/context-modals/additionalObject.html", {
				onOpen: function() {
					if (this.data.obj) {
						entitySelectionService.selected_entity = this.data.obj;
					}
				},
				selectObjectTexture: function( obj ) {
					if (obj.type != "cube" && obj.type != "plane") return;

					var self = this;
					return $rootScope.$ArtestUserBarService.OpenFileGalleryModal( true, false, {
						allow_oeuvre_select: false,
						limit: 1
					}).then(function( image ){
						if (image && (image = image[ Object.keys(image)[0] ])) {
							$rootScope.actStack.do( 'additionalObject.cube.setTexture', obj, image.uid );
							self.$modal.close();
						}
					}).catch(function( error ){
						console.error( error );
					});
				}
			});

			contextMenuService.buildTemplateScope( "templates/context-modals/gameScene.html", {
				onOpen: function() {
					var self = this;

					this.__open_tab = 'settings';

					this.changeTab = function( tab ) {
						self.__open_tab = tab;
					};

					this.selectedObject = null;
					this.selectedObject_cloneable = false;

					try {
						var obj = entitySelectionService.selected_entity;
		
						if (!obj) return null;

						/** Lisäseinää ei hyväksytä valituksi objektiksi, koska lähtökohtaisesti haluttaisiin
						 * objektilla olevan tasan yksi "sijainti", ei kahta reunaa
						 */
						if (obj instanceof WallService.AdditionalWall) return null;

						this.selectedObject = obj;
						this.__open_tab = 'selected_object';

						if (obj instanceof AdditionalObject) {
							this.selectedObject_cloneable = true;
						}
					} catch (error) {}
				}
			});

			contextMenuService.init( "game-scene-settings", "templates/context-modals/gameScene.html", {
				helpers                  : gameService.helpers,
				gameService              : gameService,
				arrangement              : arrangement
			});

			contextMenuService.init( "player", "templates/context-modals/player.html", {
				spherical360SetupService: spherical360SetupService
			});

			contextMenuService.init( "html", "templates/context-modals/html.html" );
			

			/**
			 * Asetetaan toiminnallisuus kontekstivalikon avauksen sijalle.
			 * Editorissa avataan contextMenuService'n kautta normaalisti
			 * Ei-editorissa vain teoksen "avaaminen" huomioidaan ja esitetään teoksen tiedot
			 */
			sceneContainer.oncontextmenu = function( event ){

				onMousePositionChangeEvent( event );

				//event.pointY = event.clientY - (window.innerHeight - renderer.domElement.clientHeight );
				//mouse.pos.set(( event.clientX - window.windowHalfX ) / 2,  ( event.pointY - window.windowHalfY ) / 2 );

				var intersects = screenIntersects( event.clientX, event.pointY ), target,

				first = intersects.filter(function( intr, idx, intersects ) {

					// Onko kyseessä kunnollinen objekti
					if (intr.object && intr.face) {

						// Poikkeustoiminnallisuus valojen helpperiä varten. Halutaan kohdistuvan valoon
						if (intr.object.light && (
							intr.object instanceof RectAreaLightHelper ||
							intr.object instanceof HemisphereLightHelper ||
							intr.object instanceof LightProbeHelper ||
							intr.object instanceof SpotLightHelper ||
							intr.object instanceof PointLightHelper)
						) {
							intersects[ idx ].object = intr.object = intr.object.light;
						}

						// Jos kohde on asetettu läpinäkyväksi intersect-tarkistukselle, ohitetaan se
						if (!intr.object.userData.intersectTransparent) {
							return true;
						}
					}

					if (HUDService.transformCtrl) {
						// Tarkistetaan, onko kyseessä klikkaus TransformCtrl'iin
						for (var i = 0, parent = intr.object; i < 5 && (parent = parent.parent); i++) {
							if (parent == HUDService.transformCtrl && HUDService.transformCtrl.object) {
								intersects[idx].object = HUDService.transformCtrl.object
								return true;
							}
						}
					}
				})[0];

				if (first) {

					if (gameService.editor) {

						switch (first.object.userData.type) {

							case "additionalWall":
								if (target = wallsHandlerService.solveWall( first.object.userData.obj )) {

									// Jos ennalta on valittu objekti, EI valita seinää! (voidaan haluta sijoitaa valittu objekti seinälle)
									var selected_entity = entitySelectionService.selected_entity;

									if (!selected_entity || selected_entity instanceof WallService.AdditionalWall) {

										entitySelectionService.selected_entity = target;

										console.log("asked contextmenu of additionalWall", target );

									} else console.warn( "Something else selected, skipping selecting the additional wall" );

									contextMenuService.run( "preview-additionalWall-" + target.uuid, event.clientX, event.pointY );

								} else console.warn( "Unable to solve additionalWall!", first );

								return false;

							case "additionalObject":

								if (target = additionalObjectService.solveObject( first.object )) {
									console.log("asked contextmenu of additionalObject", entitySelectionService.selected_entity = target );
									contextMenuService.run( "preview-additionalObject-" + target.uuid, event.clientX, event.pointY );
								} else console.warn( "Unable to solve additionalObject!", first );

								return false;

							case "oeuvre":

								if (target = $oeuvresHandler.solveOeuvre( first.object )) {
									console.log("asked contextmenu of oeuvre", entitySelectionService.selected_entity = target );
									contextMenuService.run( "preview-oeuvre-" + target.uid, event.clientX, event.pointY );
								} else console.warn( "Unable to solve oeuvre!", first );

								return false;

							case "dragHandle":

								if (target = dragHandlesService.solveHandle( first.object )) {

									if (target instanceof DragHandle.Polygon) {
										console.log("asked contextmenu of dragHandle", entitySelectionService.selected_entity = target );
										contextMenuService.run( "dragHandle-polygon-" + target.uuid, event.clientX, event.pointY );
									} else if (target instanceof DragHandle.Comment) {
										console.log("asked contextmenu of comment", entitySelectionService.selected_entity = target );
										contextMenuService.run( "comments", event.clientX, event.pointY, { comments: target.comments });
									} else if (target.userData.meterHandle && (target = target.userData.meter) instanceof DragHandle.Meter) {
										console.log("asked contextmenu of meter", entitySelectionService.selected_entity = target );
										contextMenuService.run( "dragHandleMeter", event.clientX, event.pointY, { obj: target });
									}
								}

								return false;

							case "world":

								console.log("asked contextmenu of world", first );
								contextMenuService.run( "game-scene-settings", event.clientX, event.pointY );

								return false;
						}

					} else {
						// Editori ei ole auki!

						if (first.object.userData.type == "oeuvre") {

							if (target = $oeuvresHandler.solveOeuvre( first.object )) {

								console.info( "asked contextmenu of oeuvre", target );

								var modal

								try {
									openOeuvreInfoModal( target.uid );
									
	//								var modal = $rootScope.$ArtestUserBarService.OpenOeuvreViewerModal({ uid: target.uid });
								} catch (error) {
									console.error( error );
								}
							}
						}
					}


					try {
						if (onPossibleObjectClickHandler( event )) throw "abort";
					} catch (error) {
						if (error == "abort") return;
						console.error( error );
					}
				}

				contextMenuService.closeAll();

				return false;
			};

			/**  /CONTEXT MENUS */


			/***************/


			/**  GENERAL USER ACTIONS */

			actStack.addActs({
				"Object.cloneObjectToScreenPoint": {
					"do": function( obj, x, y ) {

						var intersects = screenIntersects( x, y );

						var intersect = parseFirstIntersect( intersects, [ "world", "wall", "dragHandlePolygon", "additionalObject", "additionalWall" ] );

						if (!intersect) return;

						var data = {
							source_obj_uuid : obj.uuid,
							intersects       : intersects
						};

						if (obj instanceof Oeuvre) {
							data.source_obj_uuid = obj.uid;
							data.source_obj_type = "oeuvre";
						} else if (obj instanceof AdditionalObject) {
							data.source_obj_type = "AdditionalObject";
						}

						var clone_obj = actStack.acts[ "Object.cloneObjectToScreenPoint" ].redo( data );

						if (clone_obj) {
							data.clone_obj_uuid = clone_obj.uuid;

							actStack.addUndo( "Object.cloneObjectToScreenPoint", data );
						} else {
							Notification.error( gettextCatalog.getString( "Failed to clone object!" ))
						}
					},
					"undo" : function( act, obj ) {

						if (!act.clone_obj_uuid) return;

						if (act.source_obj_type == "AdditionalObject") {
							additionalObjectService.removeObject( act.clone_obj_uuid );
						}
					},
					"redo": function( act, source_obj ) {
						
						source_obj = ObjectSolverByUuid( act.source_obj_uuid, act.source_obj_type );

						if (!source_obj) {
							return;
						}

						var clone_obj = cloneObject( source_obj );

						if (!clone_obj) {
							return;
						}

						if (act.intersects) setObjectPlaceByIntersects( clone_obj, act.intersects );

						if (act.clone_obj_uuid) {
							if (typeof clone_obj.changeUuid == "function") clone_obj.changeUuid( act.clone_obj_uuid );
						}

						return clone_obj;
					}
				},
				"Object.setObjectPlaceByScreenPoint": {
					"do": function( obj, x, y ) {

						var prev_values = solveValues();

						var intersect = setObjectPlaceByScreenPoint( obj, { x: x, y: y });

						if (!intersect) {
							// Todetaan, ettei sijaintia onnistuttu asettamaan -> Virheilmoitus
							Notification.warning( gettextCatalog.getString( "The object could not be placed!" ));
						}

						var new_values = solveValues();

						var data = {
							uuid          : obj.uuid,
							prev_position : prev_values.position,
							prev_rotation : prev_values.rotation,
							new_position  : new_values.position,
							new_rotation  : new_values.rotation
						};

						if (obj instanceof Oeuvre) {
							data.uuid = obj.uid;
							data.obj_type = "oeuvre";
						} else if (obj instanceof AdditionalObject) {
							data.obj_type = "AdditionalObject";

							/**
							 * Koska AdditionalObject.setPlaceByIntersect lisää
							 * actStackiin merkinnän niin ohitetaan
							 */
							// return;
						}

						if (!obj.uuid) return;

						actStack.addUndo( "Object.setObjectPlaceByScreenPoint", data );

						function solveValues() {
							var values = {};

							// Poikkeavat tavat hankkia halutut arvot tähän

							values.position = obj.mesh.position.clone();
							values.rotation = obj.mesh.rotation.clone();

							return values;
						}
					},
					"undo" : function( act, obj ) {
						if (obj = ObjectSolverByUuid( act.uuid, act.obj_type )) {
							if (act.prev_position) obj.mesh.position.copy( act.prev_position );
							if (act.prev_rotation) obj.mesh.rotation.copy( act.prev_rotation );
						}
					},
					"redo": function( act, obj ) {
						if (obj = ObjectSolverByUuid( act.uuid, act.obj_type )) {
							if (act.new_position) obj.mesh.position.copy( act.new_position );
							if (act.new_rotation) obj.mesh.rotation.copy( act.new_rotation );
						}
					}
				}
			});


			/** /GENERAL USER ACTIONS */


			/***************/

			init__controlEventListeners();

			onResize();

			/*$scope.$watch(function() {
				var e = document.getElementById( "controls-panel" );
				return e && e.clientWidth;
			}, onResize );*/

			/***************/

			$q(function( resolve, reject ){
				if ($scope.arrangement) {
					setTimeout(function(){
						try {
							ArrangementService.applyArrangement( $scope.arrangement )
						} catch(err){
							console.error( "Failed to applyArrangement at init()" );
							console.error( err );
						}
						resolve();
					}, 250);
				} else {
					wallsHandlerService.init( oeuvres );
					resolve();
				}
			}).then(function() {
				/* Kaikki ainekset kasassa */
	//			$oeuvresHandler.oeuvres_arr.forEach(function( o ) {
	//				if (o instanceof Statue) o.setPlaceByIntersect();
	//			});

				angular.element(document.body).addClass("initializedAndReady");

				$rootScope.loading = false;

				gameService.setControlModeVisibility( false );

				$rootScope.$broadcast( gameService.inEditor() ? "editorEnabled" : "editorDisabled" );

				setTimeout(function(){
					// applyArrangement()'ssa setTimeout ja siksi tämäkin on
					helpers.hideHelpers();
				}, 10);

				loop();

				$rootScope.$broadcast( "$sceneReady" );

				return $timeout();
			}).catch(function( err ){
				console.error( err );
				debugger;
			});
		} // End Of init()

		function init__controlEventListeners() {

			sceneContainer.addEventListener( "click", onDocumentMouseClick, false );
			sceneContainer.addEventListener( "mouseup", onDocumentMouseUp, false );
			
			$(sceneContainer)
			//.on("click",     onDocumentMouseClick)
			//.on("mouseup",   function(event){ $rootScope.$digest(); return onDocumentMouseUp(event); })
			.on("touchmove",  onDocumentTouchMove)
			.on("mousemove",  onDocumentMouseMove)
			.on("touchstart", onDocumentTouchStart)
			.on("mousedown",  onDocumentMouseDown)
			.on("wheel",      onMouseWheel) // scroll
			.on("blur",       onDocumentBlur)
			.on("mouseout",   onDocumentBlur)

			if (window.keyboardState) window.keyboardState.destroy();
			keyboardState = window.keyboardState = new THREEx.KeyboardState();

			/**
			 * Koska THREEx.KeyboardState sellaisenaan asettaa addEventListener(keydown|keyup, false)'t,
			 * mutta ei käsittele sitä onko kohde-elementti oikea eikä esim. olla lomakkeessa,
			 * modifioidaan THREEx.KeyboardState'n käyttämää onKeyChange'a.
			*/
			keyboardState._onKeyChange = (function( cb ) {
				return function( event ) {

					var pressed = event.type === 'keydown' ? true : false; // THREEx.KeyboardState.prototype._onKeyChange'n käyttämä menetelmä

					if (pressed) {

						/**
						 * @TODO: Pitäisi olla käänteisesti, s.e. fokuksen on oltava 3D-näkymässä jotta hyväksytään?x
						 */
						try {
							let elem = $( document.activeElement );
							elem = elem.is( '.modal' ) ? elem : elem.parents( '.modal' );
							if (elem[0]) return;
						} catch(e) {}


						// Jos ollaan missä tahansa lomakkeessa, ei haluta tällaisten painallusten kirjautuvan
						if (document.activeElement) {
							if (document.activeElement.tagName.toUpperCase() == "INPUT")    return;
							if (document.activeElement.tagName.toUpperCase() == "TEXTAREA") return;
						}

					} else {
						// Jos ollaan poistamassa painallusta, halutaan välttää "pohjaan jääminen" ja siksi sallitaan aina _onKeyChange'n normaali toiminta
					}

					cb( event );
				}
			})( keyboardState._onKeyChange.bind( keyboardState ) );





			document.addEventListener( 'keydown', onDocumentKeyboard.bind( null, 1 ), false );
			document.addEventListener( 'keyup',   onDocumentKeyboard.bind( null, 0 ), false );

			window.addEventListener( 'resize', onResize, false );

		} // End Of init__controlEventListeners()

		function onResize() {
			var container = document.getElementById( "container" );

			/**
			 * @TODO: "#container'n canvas't vain näkyvän alan kokoiseksi, ei koko ruudun levyiseksi JOS sivupalkki on auki!"
			 * @see https://trello.com/c/q4Zdb3Vw
			try {
				var panelElem = document.getElementById( "controls-panel" );

				if (panelElem) {

					var offsetX = panelElem.clientWidth;

					if (offsetX > 0) {
						container.style.marginLeft = offsetX + "px";
						container.style.position   = "relative";
					} else {
						container.style.marginLeft = "auto";
					}
				}
			} catch (e) { } */

			var width  = container.clientWidth;
			var height = container.clientHeight;

			window.windowHalfX = width  / 2;
			window.windowHalfY = height / 2;

			player.setFov( );

			renderer.setSize( width, height );
			HUDService.onResize( width, height );
		}

		var loopCounter = 0;

		var $$lastLoopTime    = NaN; // Viimeisimmän laskennan ajankohta
		var $$lastLoopCounter = 0;   // Laskuri ruudunpäivitysten välisiin päivityksiin
		var $$lastLoopFpsN    = 10;  // Monenko ruudunpäivityksen välein FPS päivitetään

		var $$lightUpdaterCounter = 0;

		function loop() {
			try {
				if (running) {
					requestAnimationFrame( loop );

					loopCounter++;

					/**
					 * Läpikäydään takaperin $$lastLoopFpsN'sta alkaen kunnes ollaan nollassa ja arvioidaan FPS
					 */
					if (!($$lastLoopCounter--)) {
						var now   = Date.now(),
							dtime = (now - $$lastLoopTime) || 1000;

						gameService.FPS = 1000 * $$lastLoopFpsN / dtime;

						// console.debug( "FPS:", gameService.FPS );

						// try { console.debug(window._last_pos ? window._last_pos.clone().distanceTo((window._last_pos = player.pos.clone())) : (window._last_pos = player.pos.clone())) * (1000/(now - $$lastLoopTime)); } catch(e){}
						// gameService.$fpsHistory.unshift( 1000 * $$lastLoopFpsN / dtime );
						// gameService.$fpsHistory.splice( 10, 1 );

						$$lastLoopTime = now;
						$$lastLoopCounter = $$lastLoopFpsN;
					}

					if (!($$lightUpdaterCounter--)) {
						$$lightUpdaterCounter = 100;

						gameService.shadowsNeedsUpdate = true;
					}

				} else {
					gameService.FPS         = NaN;
					$$lastLoopTime          = NaN;
					$$lastLoopCounter       = 0;
				}

				update();
				render();

				if (arrangement.$editable && _autoSavingTimeout == null && autoSavingInterval > 0) {
					_autoSavingTimeout = setTimeout( autoSaveFn, autoSavingInterval );
				}
			} catch( error ){
				console.error( error );
				debugger;
			}
		}

		function update( force ) {

			player.keys.left  = player.keys.left  || 0;
			player.keys.right = player.keys.right || 0;
			player.keys.up    = player.keys.up    || 0;
			player.keys.down  = player.keys.down  || 0;

			if (keyboardState && !player.$keyboardControlsDisabled) {
				var keyboard = keyboardState;

				if (keyboard.keyCodes[ 65 ] || keyboard.keyCodes[ 37 ]) player.keys.left  += 1;
				if (keyboard.keyCodes[ 68 ] || keyboard.keyCodes[ 39 ]) player.keys.right += 1;
				if (keyboard.keyCodes[ 87 ] || keyboard.keyCodes[ 38 ]) player.keys.up    += 1;
				if (keyboard.keyCodes[ 83 ] || keyboard.keyCodes[ 40 ]) player.keys.down  += 1;
			}

			player.update();

			player.keys.left  = 0;
			player.keys.right = 0;
			player.keys.up    = 0;
			player.keys.down  = 0;

			if (gameService.LODService && gameService.LODService.enabled) {
				gameService.LODService.update();
			}
			
			if (spherical360SetupService.enabled) {
				spherical360SetupService.update();
			}

			additionalObjectService.update();

			if (player.hasMoved || force) {

				gameService.renderNeeded = true;

				dragHandlesService.dragHandlesNeedsUpdate = true;

				if (gameService.$worldBox) try {
					if (!gameService.$worldBox.containsPoint( player.headPos )) {
					}
				} catch (error) {
					console.error( error );
				}
			}

			if (dragHandlesService.dragHandlesNeedsUpdate) {

				dragHandlesService.dragHandlesNeedsUpdate = false;
				
				gameService.renderNeeded = true;

				var cs = dragHandlesService.handles.children, uniforms;

				for (let i in cs) {
					if (cs[i] instanceof DragHandle.Proto) {
						uniforms = cs[i].mesh.$glowMesh && cs[i].mesh.$glowMesh.material && cs[i].mesh.$glowMesh.material.uniforms;

						if (uniforms && uniforms.viewVector) {
							uniforms.viewVector.value = (uniforms.viewVector.value || new Vector3()).copy( player.camera.position ).sub( cs[i].position );
						}
					}
				}
			}
			
			for (let i in TextLabel.all) {
				var distance = TextLabel.all[i].position.distanceTo( player.camera.position );
				var scale    = distance / 20;

				TextLabel.all[i].scale.set( scale, scale, scale );
				TextLabel.all[i].lookAt( player.camera.position );
			}

			for (var uid in oeuvres) {
				if (oeuvres[ uid ].$lookAtPlayer) {
					oeuvres[ uid ].mesh.lookAt( player.camera.position );
				}
			}
		}

		function render() {

			if (HUDService.transformCtrl && HUDService.transformCtrl.dragging) {

				gameService.shadowsNeedsUpdate = true;
			}

			if (gameService.shadowsNeedsUpdate) {

				gameService.shadowsNeedsUpdate = false;

				gameService.renderNeeded = true;

				renderer.shadowMap.needsUpdate = true;
			}

			/**
			 * Piirretään 3D-skene
			 */
			if (gameService.renderNeeded || gameService.forceRender) {

				gameService.renderNeeded = false;

				renderer.render( $scope.scene, player.camera );
			}
			
			/**
			 * Piirretään HUD-käyttöliittymä
			 */
			// HUDService.render(); Otettu pois käytöstä toistaiseksi ylimääräisenä kerroksena 14.5.2021 -m
		}

		/*****************************/

		$scope.$on("$destroy", function(){
			console.log("view.game-scene :: $on('$destroy')");

			try {
				sceneContainer.removeEventListener( "click", onDocumentMouseClick, false );
				sceneContainer.removeEventListener( "mouseup", onDocumentMouseUp, false );
			} catch (error) {}

			try {
				if (window.keyboardState) window.keyboardState.destroy();
			} catch (error) {}

			clearTimeout( _autoSavingTimeout );
			_autoSavingTimeout = null;

			running = false;
			try {
				renderer.dispose();
			} catch (error) {}

			scene.remove();
			scene = undefined;

			helpers.remove();
			helpers = undefined;
		});

		$rootScope.$on( "onSelectionChanged", (function() {

			var mesh, idx;
			var notification;
			var direction = new Vector3();

			return function( event, selection ) {

				// Varmistetaan että voidaan käyttää valitun objektin meshia
				if (mesh = (selection.length == 1) && solveMesh( selection[0] )) {

					direction.copy( mesh.position ).sub( player.camera.position );

					// Selvitetään kameran ja objektin väliset intersectit
					var intersects = getIntersects( player.camera.position, direction );

					// Selvitetään valitun objektin indeksi intersects-taulukossa ...
					for (idx = 0; idx < intersects.length && intersects[idx].object != mesh; idx++);
					
					// ... jos se löytyy niin ...
					if (idx != intersects.length) {

						// ... parsitaan intersectseistä vain sitä edeltävät kohtaamiset
						intersects = intersects.slice( 0, idx );

						// Parsitaan vain riittävän merkittävät kohtaamiset
						if (parseFirstIntersect.wall( intersects, function(v){ return !v.userData.dragHandlePolygon; })) {

							// Objektin ja kameran välissä on *jotain* ja varoitetaan tästä.
							
							console.warn( "The selected object may not be visible!" );

							if (notification) killNotification();

							notification = Notification.warning( gettextCatalog.getString( "The selected object may not be visible!" ));

							notification.then( killNotification );
						}
					}
				}
			}

			function killNotification() {
				if (notification) {
					if (notification.kill) notification.kill();
					notification = undefined;
				}
			}

			function solveMesh( obj ) {
				if (obj.mesh) {
					switch (obj.mesh.userData.type) {
						case "additionalObject":
						case "oeuvre":
							return obj.mesh;
					}
				}
			}
		})());

		/*****************************/

		var _lastSave_json;
		function autoSaveFn() {
			if (arrangement.$editable && gameService.inEditor() && _autoSavingTimeout == null && autoSavingInterval > 0) {
				if (arrangement.uid) {
					if (player.movement_strategy == "default") {
						try {
							var save = ArrangementService.updateSavedArrangementData.buildBody( arrangement );
							var save_player = save["model_preview_arrangement.data"].player;
							delete save["model_preview_arrangement.data"].player;
							var save_json = JSON.stringify( save );
		
							if (_lastSave_json != save_json ) {
								_lastSave_json =  save_json;
							
								save["model_preview_arrangement.data"].player = save_player;
		
								console.count("autoSaving()");
		
								var json = JSON.stringify({
									save  : save,
									ctime : Date.now()
								});
								window.localStorage.setItem( "model-preview."+arrangement.uid+".save", json );
							}
						} catch( err ){
							console.error( err );
						}
					}
				}
			}
			_autoSavingTimeout = null;
		}

		/*
		███████ ██    ██ ███████ ███    ██ ████████ ███████
		██      ██    ██ ██      ████   ██    ██    ██
		█████   ██    ██ █████   ██ ██  ██    ██    ███████
		██       ██  ██  ██      ██  ██ ██    ██         ██
		███████   ████   ███████ ██   ████    ██    ███████
		*/

		function onMousePositionChangeEvent( event ) {

			let cache = onMousePositionChangeEvent.cache = onMousePositionChangeEvent.cache || {
				leftOffset: 0,
				topOffset: 0,
				expires: 0,
				clientHeight: renderer.domElement.clientHeight,
				clientWidth:  renderer.domElement.clientWidth,
				clientDiagonal: Math.sqrt( Math.pow( renderer.domElement.clientHeight, 2 ) + Math.pow( renderer.domElement.clientWidth, 2 ) )
			};

			let { timeStamp } = event;

			if (!(cache.expires > timeStamp)) {

				let { top, left } = renderer.domElement.getBoundingClientRect() || {};
				let clientHeight  = renderer.domElement.clientHeight;
				let clientWidth   = renderer.domElement.clientWidth;

				if (cache.clientHeight != clientHeight || cache.clientWidth != clientWidth) {

					if (clientHeight) cache.clientHeight = clientHeight;
					if (clientWidth)  cache.clientWidth  = clientWidth;

					cache.clientDiagonal = Math.sqrt( Math.pow( cache.clientHeight, 2 ) + Math.pow( cache.clientWidth, 2 ) );
				}

				cache.topOffset          = top  || (window.innerHeight - cache.clientHeight);
				cache.leftOffset         = left || (window.innerWidth  - cache.clientWidth);

				cache.containerHalfY     = cache.clientHeight / 2;
				cache.containerHalfX     = cache.clientWidth  / 2;

				cache.expires = timeStamp + 1000;
			}

			event.pointX = event.clientX - cache.leftOffset;
			event.pointY = event.clientY -  cache.topOffset;

			mouse.pos.set(( event.pointX - cache.containerHalfX ) / 2,  ( event.pointY - cache.containerHalfY ) / 2 );
		}

		function onDocumentTouchMove( event ) {

			if (event.touches.length > 1) console.warn( "Not implemented!" ); // @TODO: Osaa hallita!

			var touch = event.touches[0];

			if (!touch) return;

			var nevent = {
				buttons  : 1,             // Koskettaessa, ei ole kuin yksi näppäin
				shiftKey : false,         // Ei ole koskaan mahdollista kontrolloida mobiilissa!
				clientX  : touch.clientX,
				clientY  : touch.clientY
			};

			onDocumentMouseMove( nevent );
		}

		function onDocumentMouseMove( event ) {

			onMousePositionChangeEvent( event );

			//event.pointY = event.clientY - (window.innerHeight - renderer.domElement.clientHeight );
			//mouse.pos.set(( event.clientX - window.windowHalfX ) / 2,  ( event.pointY - window.windowHalfY ) / 2 );

			if (!gameService.inEditor()) {
				// Kun ei olla editorissa, ainoa mitä voidaan hiirellä tehdä on liikuttaa näkymää

				onDocumentMouseMove.moveCamera( event );

				return;
			}


			if (HUDService.transformCtrl && HUDService.transformCtrl.dragging) return;


			var intersects, first;

			var __hilight_changed = false;

			if (event.buttons != 1) { // Eihän hiiren ykköspainike ole pohjassa?
				player.av_plus = 0;

				if (gameService.inControlMode) { // Ollaanko kontrollimoodissa (Shift pohjassa)
					intersects = screenIntersects( event.clientX, event.pointY ).filter(function(v){ return !!v.face; });

					if (intersects.length > 0) { // Osoitetaanko johonkin kohteeseen?
						first = intersects[0].object;
						
						// Oliko aiemmin hilightattu?
						if (onDocumentMouseMove._hilightObject.object) {
							// Onko eri (jos on, poistetaan aiemman merkinnät)
							if (first.userData.type == "additionalObject") {
								if (onDocumentMouseMove._hilightObject.object != first.userData.additionalObject.mesh) {
									__hilight_changed = true;
								}
							} else if (onDocumentMouseMove._hilightObject.object != first) {
								__hilight_changed = true;
							}
						} else { // Aiemmin ei ollut hilightattu
							__hilight_changed = true;
						}
					} else if (onDocumentMouseMove._hilightObject.object) {
						__hilight_changed = true;
					}
				} else if (onDocumentMouseMove._hilightObject.object) {
					__hilight_changed = true;
				}
			} else if (onDocumentMouseMove._hilightObject.object) {
				__hilight_changed = true;
			}


			if (__hilight_changed) {
				if (first) {
					try {
						switch (first.userData.type) {
							case "additionalObject":
								if (first.userData.additionalObject) {
									first = first.userData.additionalObject.mesh;
								}
								break;
							case "oeuvre":
								if (first.userData.obj) {
									first = first.userData.obj.mesh;
								}
								break;
							case "additionalWall":
								if (first.userData.obj) {
									first = first.userData.obj.mesh;
								}
								break;
							case "dragHandle":
								var obj;
								if (first.userData.dragHandlePolygon) {
									obj = first.$parent;
								} else if (first.userData.dragHandle) {
									obj = first.userData.dragHandle.$parent || first.userData.dragHandle;
								}

								if (obj) {
									first = obj.faces || obj.mesh;
								} else {
									first = null;
								}
								break;
							default:
								// Kyseessä kenties LightHelper
								if (first.light && (
									first instanceof RectAreaLightHelper ||
									first instanceof HemisphereLightHelper ||
									first instanceof LightProbeHelper ||
									first instanceof SpotLightHelper ||
									first instanceof PointLightHelper)
								) {
									break; // first = first
								}
							case "world":
								first = null;
								break;
						}
					} catch (error) {
						console.error( error );
					}

					if (!first) first = null;
				}

				if (entitySelectionService.hilightObject.object != first) {

					entitySelectionService.hilightObject.object = first = first || null;

					if (entitySelectionService.hilightObject.object) {

						entitySelectionService.hilightObject.refresh();
					}
						
					entitySelectionService.hilightObject.$helper.visible = !!entitySelectionService.hilightObject.object;

					gameService.renderNeeded = true;

					$rootScope.$broadcast( "hilightChanged", first )
				}
			}

			if (event.buttons != 1) return; // Keskeytetään, jos ei hiiren ykköspainike ole painettu

			if (gameService.inControlMode) {
				intersects = intersects || screenIntersects( event.clientX, event.pointY );
				intersects = intersects.filter(function(v){ return !!v.face; });

				// Tarkastetaan, mikä kohde on valittuna
				var single_selected = entitySelectionService.selected_entity;

				if (!single_selected) { // Jollei valittuna ole tasan yhtä kohdetta raahataan objektin sijaan kameraa
					onDocumentMouseMove.moveCamera( event );
					return;
				}

				let isMoveable = isObjectMoveable( single_selected );

				if (single_selected instanceof Oeuvre) {
					var oeuvre = single_selected;
						
					oeuvre.$$prevPosition = oeuvre.$$prevPosition || oeuvre.mesh.position.clone();
					oeuvre.$$prevRotation = oeuvre.$$prevRotation || oeuvre.mesh.rotation.clone();
						
					if (first = parseFirstIntersect.wall( intersects )) {
						let point = first.point.clone(), btm_offset = gameService.opts.oeuvres.fixedBtmOffs;

						if (window.gameService.opts.game.lockToGrid == "world" && window.gameService.opts.game.lockGridSize) {
							btm_offset = window.gameService.opts.game.lockGridSize/100;
							if (oeuvre.isStatue) {
								roundVector( first.point, btm_offset );
								first.point.y = point.y;
							}
						}
						oeuvre.setPlaceByIntersect( first, btm_offset );
					}
				} else if (single_selected instanceof WallService.AdditionalWall) {
					var wall = event.target = single_selected;

					if (first = parseFirstIntersect.wall( intersects, wall.mesh )) {
						let point = first.point;

						if (window.gameService.opts.game.lockToGrid == "world" && window.gameService.opts.game.lockGridSize) {
							roundVector( point, window.gameService.opts.game.lockGridSize/100 );
						}

						if (wall.$$selectedEnd == "A") {

							wall.setEdges( point );

							gameService.shadowsNeedsUpdate = true

						} else if (wall.$$selectedEnd == "B") {

							wall.setEdges( undefined, point );

							gameService.shadowsNeedsUpdate = true
						} else {
							// Sallitaan kameran liikkuminen vaikka lisäseinä on valittu, raahaus tapahtuu ko. seinän päällä, mutta yhtään kulmaa ei
							return onDocumentMouseMove.moveCamera( event );
						}
					} else {
						// sallitaan kameran liikkuminen vaikka lisäseinä on valittu ja raahaus tapahtuu ko. seinän päällä
						return onDocumentMouseMove.moveCamera( event );
					}

				} else if (single_selected instanceof AdditionalObject) {
					var object = single_selected;

					// Tarkastetaan ettei intresectseissa ole nykyisen "osia" (
					if (first = parseFirstIntersect.wall( intersects, function( vrt ){ return vrt.userData.additionalObject != object })) {
						object.setPlaceByIntersect( first );
					}

				} else if (single_selected instanceof DragHandle ){
					var handle = single_selected;
					var parent = handle.$parent || handle;

					if (parent instanceof DragHandle.Polygon) {
						var nar = [ parent.faces ].concat( parent.faces.children );

						// Varmistetaan, että löytyy piste "seinältä"
						if (first = parseFirstIntersect.wall( intersects, function(v){ return !v.userData.dragHandlePolygon; })) {
							//console.log( first );

							/* Polygonin kulma */
							if (handle.userData.polygonHandle) {
								var polygon = handle.$parent;

								isMoveable = isObjectMoveable( polygon );

								if (isMoveable) {

									// Halutaan pitää kulmapiste polygonin muodostamalla tasolla
									if (polygon.opts.lockPlane) {

										var ray = screenPosRaycaster( event.clientX, event.pointY ).ray;
										ray.origin.sub( polygon.position );

										// avaruuden piste tasolla
										let point = ray.intersectPlane( polygon.plane, new Vector3() );

										var cl_point = first.point.clone().sub( polygon.position ); // Lähin kohdattu piste suhteessa polygonin keskipisteeseen
										// Valikoidaan lähempi, avaruuden piste tasolla vrt. lähimmän esteen piste kamerasta
										if (cl_point.distanceTo( player.camera.position ) < point.distanceTo( player.camera.position )) {
											// Pidetään piste tasolla
											point = polygon.plane.projectPoint( cl_point );
										}

										point.add( polygon.position );
										handle.setPosition( point );

									} else {
										handle.setPlaceByIntersect( first, handle.z_offset || 0 );
									}
								}
							} else {
								if (isMoveable) handle.setPlaceByIntersect( first, handle.z_offset || 0 );
							}
						}

					} else if ( handle instanceof DragHandle.Proto) {

						if (first = parseFirstIntersect.wall( intersects, handle.mesh )) {

							if ( handle instanceof DragHandle.Comment) {

							} else {

							}

							if (isMoveable) handle.setPlaceByIntersect( first, handle.z_offset || 0 );
						}
					}
				}

				if (event.clientX < 10) {
					player.av_plus += 0.001;
				} else if (event.clientX > 2 * window.windowHalfX - 10) {
					player.av_plus -= 0.001;
				} else {
					player.av_plus = 0;
				}

			} else {
				onDocumentMouseMove.moveCamera( event );
			}
		}

		entitySelectionService.hilightObject = onDocumentMouseMove._hilightObject = new (function() { // jshint ignore:line
		
			this.object = null;

			this.$helper = new BoxHelper( );
			this.$helper.visible = false;
			scene.add( this.$helper );

			this.refresh = function() {
				try {
					if (this.$helper) {
						if (this.object) {
							this.$helper.setFromObject( this.object );
						} else {
							this.$helper.visible = false;
						}
					}
				} catch( error ) {
					console.error( error );
				}
			};
		})();

		onDocumentMouseMove.moveCamera = (function(){
			var lm = new Vector2();

			return function onDocumentMouseMove_moveCamera( event ){

				if (player.$cameraControlsDisabled) return;

				player.av_plus = 0;

				let { originalPoint, refrencePoint, lastMove } = mouse;

				if (refrencePoint == null) return;

				if (event.clientX == refrencePoint.x && event.pointY == refrencePoint.y) return;
							
				lastMove = mouse.lastMove = lm.set( event.clientX, event.pointY ).sub( refrencePoint );
				refrencePoint.set( event.clientX, event.pointY );

				if (player.camera.userData.type == "bird" && player.camera.userData.lock == "top") {

					player.headPos.x += lastMove.x / 100;
					player.headPos.z += lastMove.y / 100;

				} else if (player.opts.disableVerticalCamera) {
					// Vertikaalikatselu estetty, horisontaalikatselu normaalisti
					
					player.av -= lastMove.x / 300;
					
					if (player.movement_strategy == "walker") {
						// Kävelymoodissa vertikaalikamera estettäessä 
					
						if (!player.$keyboardControlsDisabled) {
							player.keys.up = (player.keys.up || 0) + Math.max( Math.min( 50 * (player.ah - lastMove.y / 100), Math.PI / 2 ), -Math.PI / 2 );
						}

						player.ah = 0;

					} else {
						// Nollataan vertikaalikatselu
						
						player.ah = 0;
					}
				
				} else {
					// Liikutetaan kameraa normaaliin tapaan

					var factor = 1 / player.camera.zoom;

					player.av -= factor * (lastMove.x / 100);
					player.ah -= factor * (lastMove.y / 100);

					player.ah = Math.max( Math.min( player.ah , Math.PI / 2 ), -Math.PI / 2 )
				}

				if (player.av < -Math.PI) player.av =  Math.PI;
				if (player.av >  Math.PI) player.av = -Math.PI;

			};
		})();


		function onDocumentBlur( event ) {

			mouse.clearTouchdown();

			//mouse.refrencePoint = null;
			//mouse.originalPoint = null;
			//mouse.lastMove      = null;

			keyboardState._onBlur( event );
		}



		function onDocumentMouseClick( event ) {
			window.ContextMenuService.closeAll();
		}



		function onDocumentTouchStart( event ) {

			if (event.touches.length > 1) console.warn( "Not implemented!" ); // @TODO: Osaa hallita!

			var touch = event.touches[0];

			if (!touch) return;

			var nevent = {
				buttons  : 1,             // Koskettaessa, ei ole kuin yksi näppäin
				shiftKey : false,         // Ei ole koskaan mahdollista kontrolloida mobiilissa!
				clientX  : touch.clientX,
				clientY  : touch.clientY

			};

			onDocumentPointerDown( nevent );
		}

		function onDocumentMouseDown( event ) {
			onDocumentPointerDown( event );
		}
		function onDocumentPointerDown( event ) {

			onMousePositionChangeEvent( event );

			if (event.buttons != 1) {
				return;
			}

			//event.pointY = event.clientY - ( window.innerHeight-renderer.domElement.clientHeight );

			//(mouse.originalPoint = mouse.originalPoint  || new Vector2()).set( event.clientX, event.pointY );
			//(mouse.refrencePoint = mouse.referencePoint || new Vector2()).set( event.clientX, event.pointY );
			//(mouse.lastMove      = mouse.lastMove       || new Vector2()).set( 0, 0 );

			mouse.resetTouchdown( event.clientX, event.pointY );
			
			// Jatketaan ainoastaan jos ollaan editorin kontrollimoodissa
			if (!gameService.inControlMode || !gameService.inEditor()) {
				return;
			}

			var target, first, intersects = screenIntersects( event.clientX, event.pointY ).filter(function(intersect){ return !!intersect.face; });

			/** Uuden lisäseinän luominen. Menee muun edelle, eli poisvalitaan valinnat */
			if (wallsHandlerService.$$createNew ){
				entitySelectionService.selected_entity = null;

				first = intersects.filter(function(intr){
					return intr.object.userData.type == "world" || intr.object.userData.type == "additionalWall";
				})[0];

				if (first) {
					if (isUpwardFacingIntersect( first )) {
						var wall = new WallService.AdditionalWall( first.point, new Vector3( 0.1, 0, 0 ).add( first.point ), first.point.y, 2, wallsHandlerService.options.additional_wall_default_depth || 0.1 );
						wallsHandlerService.addAdditionalWall( wall );
						wall.$$selectedEnd = "B";
						wall.$$creating    = true;
						wallsHandlerService.$$createNew = false;
						entitySelectionService.selected_entity = wall;
					} else {
						console.error("Failed to create new additionalWall, floor not horizontal enough");
					}

					return;
				}
			}
			wallsHandlerService.$$createNew = false;

			var single_selected = entitySelectionService.selected_entity;

			/** Tarkastellaan voidaanko valita jokin objekti */
			//if (first = intersects.filter(function(intr){ return intr.object.userData.type; })[0]) {

			first = null;

			// Läpikäydään lähimmästä kauimmas ja etsitään lähintä sopivaa
			for (var i in intersects) {
				
				first = intersects[i];

				var type = null;

				try {
					type = first.object.userData.type;	
				} catch (e) {}

				if (!type) {
					// Koska läpinäkyvästä valosta kiinni nappaaminen on vaikeaa, koetetaan napata kiinni sen helperistä
					if (first.object.light && (
						first.object instanceof RectAreaLightHelper ||
						first.object instanceof HemisphereLightHelper ||
						first.object instanceof LightProbeHelper ||
						first.object instanceof SpotLightHelper ||
						first.object instanceof PointLightHelper)
					) {
						first.object = first.object.light;
						type = first.object.userData.type;	
					}
				}
				
				if (!type) continue;

				switch (type) {
					case "oeuvre":
						if (single_selected == (target = first.object.userData.obj)) return;

						target.refreshHelpers();

						entitySelectionService.selected_entity = target;
						return console.log( "Oeuvre selected", target );
					case "additionalWall":
						/** @NOTE: Ollaan klikattu lisäseinää -> valitaan se */
						entitySelectionService.selected_entity = target = wallsHandlerService.solveWall( first.object ) || null;
						if (!target) return;

						var diA = target.edgeA.distanceTo( first.point );
						var diB = target.edgeB.distanceTo( first.point );
						
						var maxDistance = 1;

						if (diA > maxDistance) diA = null;
						if (diB > maxDistance) diB = null;

						if (diA && diB) {
							target.$$selectedEnd = diA < diB ? "A" : "B";
						} else if (diA) {
							target.$$selectedEnd = "A";
						} else if (diB) {
							target.$$selectedEnd = "B";
						} else {
							return;
						}
						
						target.$$prevPosition = target[ "edge"+target.$$selectedEnd ].clone();

						helpers.hideHelpers();

						return console.log( "AdditionalWall selected", target, target.$$selectedEnd );
					case "additionalObject":
						/** @NOTE: Ollaan klikattu objektia -> valitaan se */
						entitySelectionService.selected_entity = target = additionalObjectService.solveObject( first.object ) || null;
						if (!target) return;

						target.$$prevPosition = target.mesh.position.clone();
						target.$$prevRotation = target.mesh.rotation.clone();

						helpers.hideHelpers();

						return console.log( "AdditionalObject selected", target );
					case "dragHandle":
						target = dragHandlesService.solveHandle( first.object ) || null;
						
						// Jos napattiin kiinni polygonin seinäelementtiosasta, ei haluta tehdä siitä valintaa
						if (target && target instanceof DragHandle.Polygon) {
							if (first.object.userData.wall) {
								target = null;
							}
						}

						entitySelectionService.selected_entity = target;

						if (!target) return;


						target.$$prevPosition = target.position.clone();
						target.$$prevRotation = target.rotation.clone();

						helpers.hideHelpers();

						return console.log( "DragHandle selected", target );
					default:
						entitySelectionService.selected_entity = null;
				}
				
				break; // Poistutaan silmukasta, enempää ei voida eikä haluta tehdä
			}
		}



		function onDocumentMouseUp( event ) {

			onMousePositionChangeEvent( event );

			$rootScope.$digest();

			let { pos, originalPoint, refrencePoint, lastMove, originalTimestamp } = mouse;

			mouse.clearTouchdown();

			//mouse.originalPoint = null;
			//mouse.refrencePoint = null;
			//mouse.lastMove      = null;

			//event.pointY = event.clientY - ( window.innerHeight-renderer.domElement.clientHeight );

			if (HUDService.transformCtrl && HUDService.transformCtrl.object) {
				HUDService.transformCtrl.dispatchEvent({ type: "mouseUp", mode: HUDService.transformCtrl.getMode() });
			}



			/**
			 * Selvitetään mahdollinen ObjectClickHandler ja jos sellainen löytyy, ajetaan se
			 */
			try {

				const CLICK_THRESHOLD_MS = 200;
				const CLICK_THRESHOLD_DIAGONAL_PRS = 1;

				if (!originalTimestamp || originalTimestamp > Date.now() - CLICK_THRESHOLD_MS) {

					var isClick = !lastMove || (lastMove.x == 0 && lastMove.y == 0);
					
					if (!isClick && refrencePoint && originalPoint) {
						let delta = 10;
						if (onMousePositionChangeEvent && onMousePositionChangeEvent.cache && onMousePositionChangeEvent.cache.clientDiagonal) {
							delta = onMousePositionChangeEvent.cache.clientDiagonal / 100;
						}
						delta *= CLICK_THRESHOLD_DIAGONAL_PRS;
						isClick = refrencePoint.distanceTo( originalPoint ) < delta; 
					}

					if (isClick) {
						if (onPossibleObjectClickHandler( event )) throw "abort";
					}
				}
			} catch (error) {
				if (error == "abort") return;
				console.error( error );
			}


			/**
			 * Selvitetään mahdollinen raahaus tai muu editoritoiminta ja sellaisen tapauksessa toteutettaan se
			 */

			var single_selected = entitySelectionService.selected_entity, target;

			if (gameService.inEditor()) {

				if (single_selected instanceof Oeuvre) {
					target = single_selected;
					if (target.$$prevPosition && target.$$prevRotation) {
						actStack.addUndo("oeuvre.move", {
							oeuvre        : target,
							prev_position : target.$$prevPosition.clone(),
							prev_rotation : target.$$prevRotation.clone(),
							new_position  : target.mesh.position.clone(),
							new_rotation  : target.mesh.rotation.clone()
						});

						gameService.shadowsNeedsUpdate = true;
					}

					if (target.$wall) {
						target.$wall.refresh();
						target.$wall.refreshOeuvres( target.uid );
					}
				} else if (single_selected instanceof AdditionalObject) {
					target = single_selected;
					if (target.$$prevPosition && target.$$prevRotation) {
						actStack.addUndo("additionalObject.move", {
							uuid:          target.uuid,
							old_position:  target.$$prevPosition.clone(),
							old_rotation:  target.$$prevRotation.clone(),
							new_position:  target.mesh.position.clone(),
							new_rotation:  target.mesh.rotation.clone()
						});

						gameService.shadowsNeedsUpdate = true;
					}
				} else if (single_selected instanceof DragHandle ){
					target = single_selected;
					if (target.$$prevPosition) {
						actStack.addUndo("dragHandle.move", {
							uuid:         target.uuid,
							old_position: target.$$prevPosition.clone(),
							//old_rotation: target.$$prevRotation.clone(),
							new_position: target.position.clone(),
							//new_rotation: target.rotation.clone()
						});

						gameService.shadowsNeedsUpdate = true;
					}
				} else if (single_selected instanceof WallService.AdditionalWall) {
					target = single_selected;
					if (target.$$creating) {
						actStack.addUndo( "additionalWall.create", {
							additionalWall: target,
							edgeA:          target.edgeA.clone(),
							edgeB:          target.edgeB.clone(),
							bottomY:        target.bottomY,
							height:         target.height,
							depth:          target.depth
						});

						gameService.shadowsNeedsUpdate = true;
					} else if (target.$$selectedEnd == "A" || target.$$selectedEnd == "B") {
						if (target.$$prevPosition) {
							actStack.addUndo("additionalWall.setEdge", {
								additionalWall: target,
								prev_edge:      target.$$prevPosition.clone(),
								edge:           target[ "edge"+target.$$selectedEnd ].clone(),
								end:            target.$$selectedEnd
							});

							gameService.shadowsNeedsUpdate = true;
						}
					}

					delete target.$$selectedEnd;
				}

				if (target) {
					delete target.$$prevPosition;
					delete target.$$prevRotation;
					delete target.$$creating;

					return;
				}
			}
			
			/**
			 * Selvitetään onko sopiva tilaisuus liikkua maailmassa
			 */
			{
				let go_to_intersect = !gameService.inEditor() && player.movement_strategy == "walker" && player.iterativeMovingTimeout == null;
			
				if (go_to_intersect) try {
				
					if (!single_selected && lastMove.x == 0 && lastMove.y == 0) {

						var intersects = screenIntersects( event.clientX, event.pointY ).filter(function( v ) { return !!v.face; });
						var intersect  = parseFirstIntersect( intersects, [ "oeuvre", "world", "wall", "dragHandlePolygon", "additionalObject", "additionalWall" ]);

						if (intersect) {
							$playerHandler.doGoToIntersect( intersect )
						}
					}
				} catch(e) {}
			}
		}

		function onMouseWheel( event ) { // Scoll event listener

			var delta = typeof event.deltaY == "undefined" ? event.originalEvent.deltaY : event.deltaY;
			delta = (delta < 0 && 1) || (delta > 0 && -1) || 0;

			if (gameService.inControlMode) {
				var single_selected = entitySelectionService.selected_entity;
				if (single_selected instanceof Statue) {
					var prev_rotation = single_selected.mesh.rotation.clone();
					single_selected.mesh.rotation.y += delta * Math.PI / 12;

					actStack.addUndo("oeuvre.move", {
						oeuvre        : single_selected,
						prev_rotation : prev_rotation,
						new_rotation  : single_selected.mesh.rotation.clone()
					});

					gameService.shadowsNeedsUpdate = true;

				} else if (single_selected instanceof Painting) {

					actStack.acts["oeuvre.setZOffset"].do( single_selected, single_selected.z_offset + delta / 10 );

				} else if (single_selected instanceof AdditionalObject) {

					single_selected.rotateOnPlane( delta * Math.PI / 12 );

					gameService.shadowsNeedsUpdate = true;

				} else if (single_selected instanceof DragHandle.Proto) {

					actStack.do( "Object.valueChange", single_selected.uuid, "dragHandlesService", "z_offset", Math.max( 0, single_selected.z_offset + delta / 10 ));

					single_selected.$lastIntersect && single_selected.setPlaceByIntersect();

					gameService.shadowsNeedsUpdate = true;

				} else {
					return;
				}

				entitySelectionService.hilightObject.refresh();

			} else {
				if (player.camera.userData.type == "bird") {
					if (!player.$cameraControlsDisabled) {
						if (delta != 0) {
							player.camera.zoom = Math.min( 25, Math.max( 0.1, player.camera.zoom * (delta > 0 ? 0.8 : 1.25)));
							player.camera.updateProjectionMatrix();
						}
					}
				} else if (spherical360SetupService.enabled) {
					if (!player.$cameraControlsDisabled && !player.$cameraZoomControlsDisabled) {
						if (delta != 0) {
							player.camera.zoom = Math.min( 5, Math.max( 0.4, player.camera.zoom * (delta > 0 ? 0.8 : 1.25)));
							player.camera.updateProjectionMatrix();
						}
					}
				} else {
					if (!player.$keyboardControlsDisabled) {
						if (delta > 0) { // "ulos/ylös"
							player.move(  1 );
						} else if (delta < 0) { // "sisään/alas"
							player.move( -1 );
						}
					}
				}
			}
		}

		function onDocumentKeyboard( factor, event ) {
			if (document.activeElement) {
				if (document.activeElement.tagName.toUpperCase() == "INPUT")    return;
				if (document.activeElement.tagName.toUpperCase() == "TEXTAREA") return;
			}

			if (event.target) {
				
			}

			var keyCode = event.keyCode.toString();

			try {
				if (keyCode != "16") window.ContextMenuService.closeAll();
			} catch( err ) { }

		

			switch (keyCode) {
				// Aina samanlaisina käytössä olevat toiminnot

				case "32": // space
					if (!player.$keyboardControlsDisabled && player.jumpable && !player.disableJumping) {
						player.yplus = player.jumpyplus; break;
					}
					break;

				case "33": // pgup
					if (!player.$keyboardControlsDisabled) player.keys.pgup   = factor;
					break;

				case "34": // pgdown
					if (!player.$keyboardControlsDisabled) player.keys.pgdown = factor;
					break;

				/* case "78":
				* player.adjustToFloor();
				* break;
				*/

				default:
					// Tilanteittain poikkeavat toiminnot

					if (arrangement.$editable && gameService.inEditor()) {

						switch (keyCode) {

							case "90": return event.type == "keyup" && event.ctrlKey && actStack.doUndo(); // Ctrl + Z
							case "89": return event.type == "keyup" && event.ctrlKey && actStack.doRedo(); // Ctrl + Y

							case "16": // Shift

								if (event.shiftKey) {

									gameService.inControlMode = true;

								} else {

									gameService.inControlMode = false;
								}

								break;
						}
					} else {

						gameService.inControlMode = false;

					}

					switch (keyCode) {
						case "27": // ESC

							entitySelectionService.unselectSelected(); // Poisvalitaan mahdollisesti valitut objektit

							wallsHandlerService.$$createNew = false;

							HUDService.refreshStateIndicator();

							break;
					}
			}
		}

		/********************************************/

		function onPossibleObjectClickHandler( event ) {

			// Ei sallita clickHandlerien käyttöä kontrollitilassa (shift-näppäin pohjassa)
			if (gameService.inControlMode) return;

			var first = ObjectClickHandler.solveIntersectHandlerFromScreenPoint( event.clientX, event.pointY );

			if (first && first.handler) {

				var handler = first.handler;

				if (handler && handler.isClickable) {

					event.$intersect    = first;
					event.$clickHandler = handler;

					var result;
					try {
						result = handler.run( event );
					} catch (error) {
						console.error( error );
					}
					if (result) return true;
				}
			}
		}

		window.setObjectPlaceByIntersects = setObjectPlaceByIntersects;
		function setObjectPlaceByIntersects( obj, intersects ) {

			var first;

			// Kaiken varalta, tietenkin
			if (!intersects) return null;

			// On jo ennalta päätetty yksittäinen (oletettavasti) intersect.
			// Sijainnin vaihto voi epäonnistua herkästi esim. vain-seinä -kohteilla
			if (!Array.isArray( intersects )) intersects = [ intersects ];


			if (obj instanceof Oeuvre) {
				if (first = parseFirstIntersect.wall( intersects )) {
					var point = first.point.clone(), btm_offset = gameService.opts.oeuvres.fixedBtmOffs;

					if (gameService.opts.game.lockToGrid == "world" && gameService.opts.game.lockGridSize) {
						btm_offset = gameService.opts.game.lockGridSize / 100;

						if (obj.isStatue) {
							roundVector( first.point, btm_offset );
							first.point.y = point.y;
						}
					}

					// @TODO: actStack'iin

					obj.setPlaceByIntersect( first, btm_offset );
				}
			} else if (typeof obj.setPlaceByIntersect == "function") {
				first = parseFirstIntersect( intersects, [ "world", "wall", "dragHandlePolygon", "additionalObject", "additionalWall" ] );
				if (first) obj.setPlaceByIntersect( first );
			}

			if (first) {
				gameService.shadowsNeedsUpdate = true;
			} 

			return first;
		}

		/**
		 * Sijoitetaan haluttu objekti tiettyyn sijaintiin projektoituna pelaajan kameran kautta
		 *
		 * @param {Object} obj   - Objekti
		 * @param {Object} point - { x: ..., y: ... }
		 * @returns [{Object}]   - intersect
		 */
		window.setObjectPlaceByScreenPoint = setObjectPlaceByScreenPoint;
		function setObjectPlaceByScreenPoint( obj, point ) {

			var intersects = screenIntersects( point.x, point.y ).filter(function(v){ return !!v.face; });

			return setObjectPlaceByIntersects( obj, intersects );
		}


		/**
		 *
		 *
		 */
		function cloneObjectToScreenPoint( source_obj, point ) {

			var clone_obj;

			try {
				clone_obj = cloneObject( source_obj );
			} catch (error) {
				console.error( error );
			}

			if (!clone_obj) {
				Notification.warn({
					title: gettextCatalog.getString( "Unable to redo!" ),
					message: gettextCatalog.getString( "Object clone failed!" )
				});
				return;
			}

			var first;

			try {
				first = setObjectPlaceByScreenPoint( clone_obj, point );
			} catch (error) {
				console.error( error );
			}

			if (!first) {
				Notification.warn({
					title: gettextCatalog.getString( "Unable to redo!" ),
					message: gettextCatalog.getString( "Placing the object failed!" )
				});
			}

			return clone_obj;
		}
		window.cloneObjectToScreenPoint = cloneObjectToScreenPoint;


		function cloneObject( source_obj ) {

			if (source_obj instanceof AdditionalObject) {

				return additionalObjectService.duplicateObject( source_obj );

			}
		}
	}
}
